/**
 * remove item in array using id
 * @param arr - item array
 * @param nextItem  - item to be removed
 */
export default function removeItemInArray<
  T extends { id: string; [key: string]: any },
>(arr: T[], nextItem: T): T[] {
  const itemId = arr.findIndex((el) => el.id === nextItem.id);

  if (itemId < 0) {
    return arr;
  }

  return [...arr.slice(0, itemId), ...arr.slice(itemId + 1)];
}
